import { keepPreviousData, useQuery, type UseQueryOptions } from '@tanstack/vue-query';
import type { Ref } from 'vue';
import type { RecordsListFetchParams, TransferRow } from '@/types';
import ApiRequest from '@/plugins/store/actions/api/ApiRequest';

const DEFAULT_OPTIONS = {
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 5, // 5 minutes
};

export const queryKeys = {
    getTransfersRoot: ['transfers'],
    transfersWithParams: (params: Ref<RecordsListFetchParams>) => [...queryKeys.getTransfersRoot, params],
};

/**
 * Every move of pigs out of the selected period and location scope, unpaged. The page derives its
 * weekly bins, facet option sets and footer totals from this one array, so there is no server-side
 * paging or filtering contract to keep in step.
 *
 * `location_ids` filters the source side only: a row is a transfer the caller's own locations sent,
 * whatever the destination turns out to be. Pig type is not sent — the caller narrows
 * `locationIds` through `getSelectedSiteIdsFilteredByPigType` before handing them over.
 */
export function useTransfers(fetchParams: Ref<RecordsListFetchParams>, options: UseQueryOptions<TransferRow[]> = {}) {
    return useQuery<TransferRow[]>({
        queryKey: queryKeys.transfersWithParams(fetchParams),
        // Request behaviour goes to the constructor; `send`'s third argument is the body.
        queryFn: () => new ApiRequest({ skipLoadingIndicator: true }).send('get', `records/transfers?${fetchParams.value.period}&location_ids=${fetchParams.value.locationIds.join(',')}`),
        placeholderData: keepPreviousData,
        ...DEFAULT_OPTIONS,
        ...options,
    });
}
